<template>

	<div>
		<div v-show="phone" class="company_profile" @click="foothide()">
		  <video id="my_video" class="video-js vjs-default-skin vjs-fluid" loop preload="auto" width="100%" poster="../assets/background.jpg" data-setup="{}">
				<source src="../assets/company_profile.mp4" type='video/mp4'>
				<source src="" type='video/webm'>
					您的浏览器版本过低不支持 video 标签。
			</video>
			<div class="company_profile_head" v-show="logo_show">
				<img src="../assets/logo_first.png" alt="">
				<div @click="play()">
					<img src="../assets/play_btn.png" alt="">
				</div>
				<p v-if="lang">用玩的态度探索全新生活方式</p>
				<p v-else class="english">Explore new ways of life with playful attitude</p>
			</div>
			<div class="company_card_1">
				<p>
					<span v-if="lang">关于放学嗨</span>
					<span v-else class="english">About Afterschool</span>
				</p>
				<p>
					<span v-if="lang">
						放学嗨成立于<span class="english">2016</span>年，涵盖演出现场、新媒体、音乐出版、艺人经纪、视觉设计、影像制作、电子商务七大版块，此外业务还延伸至潮流展、嘉年华、服饰设计等多个领域。旗下拥有国内首届嘻哈音乐节<span class="english">AYO！</span>嘻哈音乐节和嘻哈音乐厂牌<span class="english">AFSC</span>。通过嘻哈音乐作为切入点，进而影响并引领中国青年文化，为中国音乐产业的发展创造良好的环境。
					</span>
					<span v-else class="english">
						Afterschool, founded in 2016, coversseven sections that the show, new media, music releasing, artist managing, visual design, video production, and electronic commerce. In addition, the business extends to many fields, such as the fashion exhibition, the carnival, the dress design and so on. We haveAYO！HipHop Music Festival that the first HipHop music festival in China! and hip-hop music Label AFSC. Through hip-hop music, it will further influence and guide Chinese youth culture and create a good environment for the development of China's music industry.
					</span>
				</p>
				<p>
					<span v-if="lang">
						目前，放学嗨成功举办两届<span class="english">AYO！</span>嘻哈音乐节，以及<span class="english">Livehouse</span>、艺人巡演等演出；<span class="english">AFSC</span>厂牌拥有法老、<span class="english">TOY</span>王奕、<span class="english">Lil Jet</span>、王愚、<span class="english">HA$</span>五组艺人，都是国内非常具有影响力的艺术家。
					</span>
					<span v-else class="english">
						At present,Afterschool has successfully held two AYO! Hiphop Music Festival, as well as the Livehouse, the artist tour, and so on. The Label AFSC owns five groups of artists, Pharaoh, TOY Wong, Lil Jet, Wang Yu and HA$.
					</span>
				</p>
			</div>
			<div id="card2" class="company_card_2">
				<p>
					<span v-if="lang">旗下品牌</span>
					<span class="english" v-else>Brands</span>
				</p>
				<div class="company_card_logo clear">
					<div class="company_card_logo_1">
						<div class="clear"><img src="../assets/card_logo_1.png" alt=""></div>
						<div class="clear">
							<span v-if="lang">
								<span class="english">AYO！</span>音乐节，是中国首个嘻哈音乐节，已成功举办2届，是目前国内最大型的嘻哈音乐节
							</span>
							<span v-else class="english">
								AYO! Music Festival, the first hip hop festival in China, has been successfully held for 2 times. It is the largest hip-hop festival in China.
							</span>
						</div>
					</div>
					<div class="company_card_logo_2">
						<div><img src="../assets/card_logo_2.png" alt=""></div>
						<div>
							<span v-if="lang">
								<span class="english">AFSC</span>厂牌,专注于<span class="english">HIPHOP</span>音乐，打造亚洲最具独特<span class="english">HIPHOP</span>厂牌
							</span>
							<span v-else class="english">
								Label AFSC, focus on HIPHOP music, build the most unique hiphop Label in Asia.
							</span>
						</div>
					</div>
				</div>
			</div>
			<div id="card3" class="company_card_3">
				<p>
					<span v-if="lang">我们的业务</span>
					<span v-else class="english">
						Our business
					</span>
				</p>
				<div class="company_card_logo clear">
					<div>
						<div class="clear"><img src="../assets/service_logo_1.png" alt=""></div>
						<div class="clear">
							<span v-if="lang">
								音乐节合作
								<br>
								中小型活动服务
								<br>
								团队建设
							</span>
							<span v-else class="english">
								Music Festival Cooperation
								<br>
								Activity Service
								<br>
								Team Building
							</span>
						</div>
					</div>
					<div>
						<div><img src="../assets/service_logo_2.png" alt=""></div>
						<div>
							<span v-if="lang">
								票务代理
								<br>
								媒体推广
								<br>
								平面&视频制作
							</span>
							<span v-else class="english">
								Ticket Agent
								<br>
								Media Promotion
								<br>
								Picture&Vedio Production
							</span>
						</div>
					</div>
					<div>
						<div><img src="../assets/service_logo_3.png" alt=""></div>
						<div>
							<span v-if="lang">
								艺人<span class="english">Booking</span>
								<br>
								艺人合作
							</span>
							<span v-else class="english">
								Artists Booking
								<br>
								Artists Cooperation
							</span>
						</div>
					</div>
				</div>
				<p>
					<span v-if="lang">
						业务联系，请发送邮件至：<span class="english">info@fangxuehai.cc</span>
					</span>
					<span v-else class="english">
						Business contact , please send email to: info@fangxuehai.cc
					</span>
				</p>
			</div>
			<div  id="card4" class="company_card_4">
				<p>
					<span v-if="lang">加入我们</span>
					<span class="english" v-else>Join us</span>
				</p>
				<div><img src="../assets/logo_first.png" alt=""></div>
				<div>
					<span v-if="lang">
						加入放学嗨，请发送简历至：<span class="english">marco@fangxuehai.cc</span>
					</span>
					<span v-else class="english">
						Join Afterschool, please send email to: marco@fangxuehai.cc
					</span>
				</div>
			</div>
			<div class="company_card_5">
				<p v-if="lang">派嗨拜浪 ( 上海 ) 网络科技有限公司版权所有©2016【 沪ICP备16032276号 】</p>
		    <p v-else class="english">PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD. All rights reserved©2016[Shanghai ICP no. 16032276]</p>
		    <p v-if="lang">本网站由派嗨拜浪 ( 上海 ) 网络科技有限公司提供</p>
		    <p v-else class="english">This website is provided by PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD</p>
			</div>
			<transition name="mybox">
	      <div  class="footer" v-show="fot_show"  @click.stop="footShow()">
	        <div><span v-if="lang">邮箱：</span><span v-else class="english">email: </span><span class="english">fxh@fangxuehai.cc</span></div>
	        <div>
	          <span v-if="lang">地址：上海市 杨浦区 军工路 100号 18栋 放学嗨</span>
	          <span v-else class="english">address: Afterschool, Building 18，No. 100, Jungong Road, Yangpu District, Shanghai</span>
	        </div>
	        <div v-on:click="link_to()" class="link_to">
	          <img src="../assets/sina_logo.png" alt="">
	          <span v-if="lang"> 放学嗨</span>
	          <span v-else class="english"> Afterschool</span>
	        </div>
	        <div>
	          <div>
	            <p><img src="../assets/wx_fxh.jpg" alt=""></p>
	            <p><img src="../assets/wx_logo.png" alt=""><span v-if="lang"> 放学嗨</span>
	          <span v-else class="english"> Afterschool</span></p>
	          </div>
	          <div>
	            <p><img src="../assets/wx_afsc.jpg" alt=""></p>
	            <p><img src="../assets/wx_logo.png" alt=""><span class="english"> AFSC</span></p>
	          </div>
	        </div>
	        <div class="company_card_5">
			  		<p v-if="lang">派嗨拜浪 ( 上海 ) 网络科技有限公司版权所有©2016【 沪ICP备16032276号 】</p>
	          <p v-else class="english">PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD. All rights reserved©2016[Shanghai ICP no. 16032276]</p>
	          <p v-if="lang">本网站由派嗨拜浪 ( 上海 ) 网络科技有限公司提供</p>
	          <p v-else class="english">This website is provided by PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD</p>
	        </div>
	      </div>
	    </transition>
	    <div id="click_btn" @click.stop="footShow()" class="phone_us" :style="{border: '2px solid #' + bordercolor,backgroundColor: '#' + bgcolor,color: '#' + bordercolor}">
	    	<span v-if="lang">联系我们</span>
	      <span v-else class="english">Contact us</span><span :style="{backgroundColor:'#'+bordercolor}"></span>
	    </div>
	  </div>
	  <div v-show="!phone" class="phone_company">
	  	<phone_company :lang="lang"></phone_company>
	  </div>
	</div>

</template>

<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import phone_company from './phone_company'

export default {
  name: 'CompanyProfile',
  components: {
  	phone_company,
  },
  props:["lang"],
  data () {
    return {
      msg: '22',
      myPlayer: "",
      myPlayer2: "",
      logo_show: true,
      ost_top: '',
      card2: '',
      bordercolor: 'FFFB00',
      bgcolor: '000000',
      fot_show: false,
      flag: true,
      scrollTop: 0,
      card3: "",
      card4: "",
      phone: true
    }
  },
  methods: {
  	play () {
  		console.log(this.myPlayer.play())
  		this.myPlayer.play();
  		this.logo_show = false;
  	},
  	handleScroll () {
      this.scrollTop = window.pageYOffset  //用于FF
            || document.documentElement.scrollTop
            || document.body.scrollTop
            || 0;
      this.ost_top = document.getElementById('click_btn').offsetTop + this.scrollTop
      this.card2 = document.getElementById('card2').offsetTop
      this.card3 = document.getElementById('card3').offsetTop
      this.card4 = document.getElementById('card4').offsetTop
      if ( this.flag == true  ) {
        if ( this.ost_top > this.card2 && this.ost_top < this.card3 ) {
	        this.bordercolor = '000000'
	        this.bgcolor = 'FFFB00'
	      }else if ( this.ost_top > this.card4 ) {
	      	this.bordercolor = '000000'
	        this.bgcolor = 'FFFB00'
	      }else if ( this.ost_top > this.card3 && this.ost_top < this.card4 ) {
	        this.bordercolor = 'FFFB00'
	        this.bgcolor = '000000'
	        /*setTimeout(() => {
	          this.bordercolor = 'FFFB00'
	          this.bgcolor = '000000'
	        },1000);*/
	      }else {
	      	this.bordercolor = 'FFFB00'
	        this.bgcolor = '000000'
	      }
      }
    },
    footShow () {
      this.fot_show = !this.fot_show;;
      this.flag = false;
      if ( this.fot_show == false ) {
        if ( this.ost_top > this.card2 && this.ost_top < this.card3 ) {
	        this.bordercolor = '000000'
	        this.bgcolor = 'FFFB00'
	      }else if ( this.ost_top > this.card4 ) {
	      	this.bordercolor = '000000'
	        this.bgcolor = 'FFFB00'
	      }else if ( this.ost_top > this.card3 && this.ost_top < this.card4 ) {
	        this.bordercolor = 'FFFB00'
	        this.bgcolor = '000000'
	        /*setTimeout(() => {
	          this.bordercolor = 'FFFB00'
	          this.bgcolor = '000000'
	        },1000);*/
	      }else {
	      	this.bordercolor = 'FFFB00'
	        this.bgcolor = '000000'
	      }
        this.flag = true;
      }else {
        setTimeout(() => {
          this.bordercolor = '000000'
          this.bgcolor = 'FFFB00'
        },200);
      }
    },
    foothide () {
      this.fot_show = false;
      this.flag = true;
      this.bordercolor = 'FFFB00'
      this.bgcolor = '000000'
      this.ost_top = document.getElementById('click_btn').offsetTop + this.scrollTop
      this.card2 = document.getElementById('card2').offsetTop
      this.card3 = document.getElementById('card3').offsetTop
      this.card4 = document.getElementById('card4').offsetTop
      console.log(this.ost_top + "__________" + this.card2  +  this.card3 )
      if ( this.ost_top > this.card2 && this.ost_top < this.card3 ) {
        this.bordercolor = '000000'
        this.bgcolor = 'FFFB00'
      }else if ( this.ost_top > this.card4 ) {
      	this.bordercolor = '000000'
        this.bgcolor = 'FFFB00'
      }else if ( this.ost_top > this.card3 && this.ost_top < this.card4 ) {
        this.bordercolor = 'FFFB00'
        this.bgcolor = '000000'
        setTimeout(() => {
          this.bordercolor = 'FFFB00'
          this.bgcolor = '000000'
        },200);
      }
    },
    link_to () {
      window.location.href="https://weibo.com/u/5692890069?refer_flag=1001030101_&is_hot=1"
    },
    IsPC () {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  mounted () {

  	// console.log(this.phone);
  	this.phone = this.IsPC();
  	if ( this.phone == true ) {
			document.getElementById('ayo_icon').style.display = "inline-block";
	    document.getElementById('ayo_icon_2').style.display = "none";
	    document.getElementById('afsc_icon').style.display = "inline-block";
	    document.getElementById('afsc_icon_2').style.display = "none";
	  	this.myPlayer = videojs(document.getElementById('my_video'));
	  	this.ost_top = document.getElementById('click_btn').offsetTop
	    console.log(this.ost_top);
	    window.addEventListener('scroll', this.handleScroll)
  	}else {

  	}

  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	.company_profile {
		width: 100%;
  	min-width: 980px;
	}

	.my_video-dimensions {
		width: 100%;
	}

	.company_profile_head {
		position: absolute;
		width: 100%;
  	min-width: 980px;
		top: 0;
		background-color: transparent;
		color: #FFFFFF;
		font-size: 24px;
		font-family: Heavy;
		transition: 20s all;
		&>img {
			margin-top: 12%;
			margin-bottom: 70px;
			width: 25%;
		}
		&>div>img {
			width: 7%;
			&:hover {
				cursor: pointer;
			}
		}
		p {
			margin-top: 3%;
			letter-spacing: 4px;
		}
	}


	.company_card_1 {
		width: 100%;
		background-color: #000000;
		p {
			margin: 0 auto;
			width: 640px;
		}
		p:nth-child(1) {
			color: #FFFB00;
			padding-top: 35px;
			padding-bottom: 52px;
			font-family: Heavy;
			font-size: 26px;
			text-align: center;
		}
		p:nth-child(n+2) {
			color: #E7E300;
			font-size: 14px;
			text-align:justify;
			letter-spacing: 1px;
			font-family: Regular;
		}
		p:nth-child(3) {
			margin-top: 50px;
			padding-bottom: 40px;
		}
	}
	.company_card_2 {
		background-color: #FFFB00;
		padding-bottom: 40px;
		p {
			margin: 0;
			width: 100%;
			color: #000000;
			padding-top: 35px;
			padding-bottom: 45px;
			font-family: Heavy;
			font-size: 26px;
			text-align: center;
		}
		.company_card_logo {
			width: 580px;
			margin: 0 auto;
			&>div {
				width: 260px;
				float: left;
			}
			.company_card_logo_1 {
				div {
					width: 100%;
					img {
						width: 70%
					}
				}
				div:nth-child(2) {
					font-family: Regular;
					margin-top: 20px;
					color: #000000;
					font-size: 16px;
					text-align: justify;
					letter-spacing: 1px;
				}
			}
			.company_card_logo_2 {
				float: right;
				div {
					width: 100%;
					img {
						width: 70%
					}
				}
				div:nth-child(2) {
					font-family: Regular;
					margin-top: 20px;
					color: #000000;
					font-size: 16px;
					letter-spacing: 1px;
					text-align:justify;
				}
			}
		}
	}
	.company_card_3 {
		background-color: #000000;
		p {
			margin: 0;
			width: 100%;
			color: #FFFB00;
			padding-top: 35px;
			font-family: Heavy;
			font-size: 26px;
			text-align: center;
		}
		.company_card_logo {
			width: 890px;
			margin: 0 auto;
			&>div {
				width: 260px;
				float: left;
				div:nth-child(2) {
					font-family: Heavy;
					margin-top: 20px;
					color: #FFFB00;
					font-size: 20px;
				}
			}
			&>div:nth-child(1) {
				width: 270px;
				margin-right: 50px;
				div {
					width: 100%;
					img {
						width: 100%
					}
				}
			}
			&>div:nth-child(2) {
				div {
					width: 100%;
					img {
						width: 60%
					}
				}
			}
			&>div:nth-child(3) {
				float: right;
				div {
					width: 100%;
					img {
						width: 90%
					}
				}
			}
		}
		p:nth-child(1) {
			padding-bottom: 75px;
		}
		p:last-child {
			padding-top: 75px;
			padding-bottom: 45px;
		}
	}
	.company_card_4 {
		background-color: #FFFB00;
		p {
			margin: 0;
			width: 100%;
			color: #000000;
			padding-top: 25px;
			padding-bottom: 35px;
			font-family: Heavy;
			font-size: 26px;
			text-align: center;
		}
		img {
			margin-top: 30px;
			margin-bottom: 30px;
			width: 28%;
		}
		&>div:last-child {
			margin: 0;
			width: 100%;
			color: #000000;
			padding-top: 25px;
			padding-bottom: 80px;
			font-family: Heavy;
			font-size: 24px;
			text-align: center;
		}
	}
	.company_card_5 {
		width: 100%;
		background-color: #FFFB00;
		padding-bottom: 20px;
		p {
			margin: 0;
			width: 100%;
			color: #000000;
			font-family: Regular;
			font-size: 12px;
			text-align: center;
		}
	}
	.phone_us {
    position: fixed;
    bottom: 100px;
    left: 160px;
    text-align: left;
    width: 100px;
    padding-left: 3px;
    font-family: Regular;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    z-index: 100;
    &:hover {
      cursor: pointer;
    }
    span:nth-child(2) {
      display: inline-block;
      width: 3px;
      height: 3px;
      margin-left: 35px;
      margin-bottom: 1.5px;
      vertical-align: middle;
      border-radius: 50%;
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 380px;
    background: #FFFB00;
    padding-top: 10px;
    p {
      margin: 0;
    }
    &>div:nth-child(-n+3) {
      color: #000000;
      margin-top: 20px;
      margin-bottom: 20px;
      height: 20px;
      line-height: 20px;
      font-family: Heavy;
    }
    &>div:nth-child(3) {
      span {
        display: inline-block;
        padding-top: 5px;
        vertical-align: top;
      }
    }
    &>div:nth-child(4) {
      display: flex;
      margin-top: 40px;
      margin-bottom: 40px;
      justify-content: center;
      &>div:first-child {
        margin-right: 80px;
      }
      span {
        color: #000000;
        display: inline-block;
        font-family: Heavy;
        vertical-align: top;
      }
    }
  }

  .mybox-leave-active,.mybox-enter-active{
      transition:  all 1s ease;
  }

  .mybox-leave-active,.mybox-enter{
      height:0px !important;
  }

  .mybox-leave,.mybox-enter-active {
      height: 380px;
  }

  .phone_company {
  	width: 100%;
  	overflow: hidden;
  }

  


	
</style>



// WEBPACK FOOTER //
// src/components/CompanyProfile.vue